import React, { useEffect } from 'react';
import { Quote } from 'lucide-react';

const FOUNDER_IMG = 'https://customer-assets.emergentagent.com/job_eco-consult-hub/artifacts/sugur4l6_Screenshot_20250912_175910_Instagram-removebg-preview.png';

const FoundersMessagePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="founders-message-page bg-white" data-testid="founders-page">
      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 bg-[#F8FAFC] border-b border-slate-200">
        <div className="container mx-auto">
          <div className="max-w-3xl">
            <div className="accent-line mb-6" />
            <span className="overline">Leadership</span>
            <h1 className="text-black mt-4 mb-6">Founder's Message</h1>
            <p className="text-lg md:text-xl text-black leading-relaxed">
              A vision to transform environmental responsibility into measurable, actionable, and profitable outcomes
            </p>
          </div>
        </div>
      </section>

      {/* Founder Profile & Message */}
      <section className="py-20 md:py-28 bg-white">
        <div className="container mx-auto">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-3 gap-12 items-start">
              {/* Founder Image */}
              <div className="md:col-span-1">
                <div className="relative">
                  <div className="absolute -top-4 -left-4 w-20 h-20 border-t-2 border-l-2 border-[#047857] z-10" />
                  <img
                    src={FOUNDER_IMG}
                    alt="Shailendra Singh Rao"
                    className="w-full object-cover border border-slate-200 shadow-soft"
                    style={{ aspectRatio: '3/4' }}
                  />
                  <div className="absolute -bottom-4 -right-4 w-20 h-20 border-b-2 border-r-2 border-[#0EA5E9] z-10" />
                </div>
                <div className="mt-8">
                  <h3 className="text-2xl font-bold text-black">Shailendra Singh Rao</h3>
                  <p className="text-black font-semibold mt-2">Founder & Managing Director</p>
                  <p className="text-black text-sm mt-1">Creduce Technologies Private Limited</p>
                </div>
              </div>

              {/* Message Content */}
              <div className="md:col-span-2">
                <Quote className="w-12 h-12 text-[#047857] mb-6" />
                <div className="space-y-6 text-black leading-relaxed text-lg">
                  <p>
                    At Creduce, our journey began with a simple yet powerful belief — that <strong>climate action must not remain a choice; it must become an economy.</strong>
                  </p>
                  <p>
                    When I founded Creduce, the vision was clear: to transform environmental responsibility into measurable, actionable, and profitable outcomes. Over the years, we have grown into one of India's most trusted climate change mitigation consulting companies — a pioneer in <strong>Carbon Credit Development, Renewable Energy, Sustainability, and ESG services.</strong>
                  </p>
                  <p>
                    Our mission has always been twofold — to <strong>decarbonize industries</strong> and <strong>democratize climate benefits.</strong> Every project we undertake is a step toward balancing development with accountability, innovation with impact. From enabling organizations to achieve carbon neutrality to trading high-integrity carbon credits globally, we empower businesses to lead the transition toward a sustainable future.
                  </p>
                  <p className="text-xl font-semibold text-black italic border-l-2 border-[#0EA5E9] pl-6">
                    But Creduce is not just a company — it is a movement.
                  </p>
                  <p>
                    A movement of thinkers, technologists, and environmental economists united by one purpose: to create a low-carbon world where economic growth aligns with planetary well-being.
                  </p>
                  <p>
                    As we step into a new era of climate finance, digital transformation, and global cooperation, Creduce continues to stand at the forefront — innovating solutions, fostering trust, and driving measurable climate outcomes for governments, corporates, and communities alike.
                  </p>
                  <p className="text-black font-semibold text-lg">
                    The climate clock is ticking. Action must accelerate.<br />
                    At Creduce, we are proud to be part of that solution — leading change, one carbon credit at a time.
                  </p>
                </div>
              </div>
            </div>

            {/* Commitment Card */}
            <div className="mt-16 bg-[#047857] text-white p-10 md:p-16 text-center relative overflow-hidden">
              <div className="absolute inset-0 grid-pattern opacity-10 pointer-events-none" />
              <div className="relative z-10">
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">Our Commitment</h3>
                <p className="text-white/90 text-lg max-w-3xl mx-auto">
                  Leading the transition to a sustainable future where environmental responsibility drives economic growth and every organization contributes to planetary well-being.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FoundersMessagePage;
